import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const navState = useMemo(() => ({ from: location.pathname }), [location.pathname]);
  if (!user) {
    return <Navigate to="/splash" state={navState} replace />;
  }
  return children;
}
